import { Gym } from 'fitbeat.models';
import React, { CSSProperties, useState } from 'react';
import { connect } from 'react-redux';
import { currentGymSelector } from '../adminSettings/selector';
import { logout } from '../auth';
import ConfirmationModal from '../members/components/confirmationModal';
import { IAppStore } from '../rootReducer';

interface IConfigurationSection {
  key: string;
  title: string;
  description: string;
  // Hides the section until its view has been built. Delete it to show the section.
  hideSection?: boolean;
}

const configurationSections: IConfigurationSection[] = [
  {
    key: 'companies',
    title: 'Companies',
    description: 'Companies for this gym will be set up here.',
    hideSection: true,
  },
  {
    key: 'onboardingQuestions',
    title: 'Onboarding Questions',
    description: 'The default and per company onboarding questions will be defined here.',
    hideSection: true,
  },
  {
    key: 'teams',
    title: 'Teams',
    description: 'The main challenge and the tagging of its teams will be configured here.',
    hideSection: true,
  },
];

const styles: { [key: string]: CSSProperties } = {
  gymName: {
    margin: 0,
    fontWeight: 500,
  },
  body: {
    display: 'flex',
    flexDirection: 'row',
  },
  menu: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minWidth: '14rem',
    borderRight: '1px solid lightgray',
  },
  menuItem: {
    padding: '10px 15px',
    textAlign: 'left',
  },
  selectedMenuItem: {
    padding: '10px 15px',
    textAlign: 'left',
    fontWeight: 700,
  },
  content: {
    padding: '10px 25px',
  },
};

interface IProps {
  currentGym: Gym;
  canUpdateGymConfig: boolean;
}

const GymSettings: React.FC<IProps> = ({ currentGym, canUpdateGymConfig }) => {
  const sections = canUpdateGymConfig ? configurationSections.filter((section) => !section.hideSection) : [];
  const [selectedSectionKey, setSelectedSectionKey] = useState<string | null>(null);
  const [confirmingLogout, setConfirmingLogout] = useState(false);
  const selectedSection = sections.find((section) => section.key === selectedSectionKey) ?? sections[0];

  return (
    <div className='app-wrapper'>
      <div className='member-detail-header'>
        <h2>Gym Settings</h2>
        <p style={styles.gymName}>{currentGym.displayName}</p>
      </div>
      <div style={styles.body}>
        <div style={styles.menu}>
          {sections.map((section) => (
            <button
              type='button'
              key={section.key}
              className='jr-btn-no-border'
              style={section.key === selectedSection?.key ? styles.selectedMenuItem : styles.menuItem}
              onClick={() => setSelectedSectionKey(section.key)}
            >
              {section.title}
            </button>
          ))}
          <button
            type='button'
            className='jr-btn-no-border'
            style={styles.menuItem}
            onClick={() => setConfirmingLogout(true)}
          >
            Logout
          </button>
        </div>
        {selectedSection && (
          <div style={styles.content}>
            <h3>{selectedSection.title}</h3>
            <p>{selectedSection.description}</p>
          </div>
        )}
      </div>
      <ConfirmationModal
        showConfirmationModal={confirmingLogout}
        titles={{ titleAction: 'Logout', questionAction: 'log out' }}
        isFetching={false}
        onClose={() => setConfirmingLogout(false)}
        onCancel={() => setConfirmingLogout(false)}
        onYesClick={logout}
      />
    </div>
  );
};

const mapStateToProps = (state: IAppStore) => ({
  currentGym: currentGymSelector(state),
  canUpdateGymConfig: state.adminSettings.canUpdateGymConfig,
});

export default connect(mapStateToProps, null)(GymSettings);
